import { useCallback, useEffect, useMemo, useState } from 'react';
import { getValoraciones } from '../api/valoracionFuncionalApi';
import { formatDateDDMMYYYY } from '../utils/valoracionFormatters';

export const useValoracionTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterPaciente, setFilterPaciente] = useState('');
  const [filterProfesional, setFilterProfesional] = useState('');

  const fetchValoraciones = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getValoraciones();
      const mapped = data.map((item) => ({
        id: item.codigo,
        idTipo: item.codigo,
        paciente: `${item.paciente.firstname} ${item.paciente.lastname}`,
        profesional: item.user ? `${item.user.firstname} ${item.user.lastname}` : 'N/A',
        pacienteId: item.paciente.id,
        fechaRaw: item.createdAt,
        fecha: formatDateDDMMYYYY(item.createdAt),
      }));
      setRows(mapped);
    } catch (error) {
      console.error('Error fetching valoraciones:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchValoraciones();
  }, [fetchValoraciones]);

  const filteredRows = useMemo(
    () =>
      rows.filter(
        (row) =>
          (!filterPaciente || row.paciente.toLowerCase().includes(filterPaciente.toLowerCase())) &&
          (!filterProfesional || row.profesional.toLowerCase().includes(filterProfesional.toLowerCase()))
      ),
    [rows, filterPaciente, filterProfesional]
  );

  return {
    loading,
    rows: filteredRows,
    filterPaciente,
    filterProfesional,
    setFilterPaciente,
    setFilterProfesional,
    fetchValoraciones,
  };
};
